import styled, { css } from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { getFont } from '@finect/tabular-utils/getFont';
export var Label = styled.span.withConfig({
  displayName: "partials__Label",
  componentId: "sc-1xd24il-0"
})(["box-sizing:content-box;display:inline-flex;position:relative;align-items:center;width:100%;padding:0 12px 0 0;border-radius:4px;font-size:11px;text-align:center;user-select:none;", ";span{font-weight:600;color:", ";", ";", "}", " ", ""], fontSmoothing, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, textEllipsis, getFont(0, 'xcompact'), function (props) {
  return props.variant === 'primary' && css(["border:1px solid ", ";background:transparent;color:", ";"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.primary;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.primary;
  });
}, function (props) {
  return props.variant === 'light' && css(["border:1px solid ", ";background:transparent;color:", ";&:hover{opacity:1;color:", ";}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.terciary;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.terciary;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.terciary;
  });
});
export var Verified = styled.div.withConfig({
  displayName: "partials__Verified",
  componentId: "sc-1xd24il-1"
})(["position:absolute;bottom:-", "px;right:-", "px;width:", "px;height:", "px;border-radius:", "px;background-color:", ";color:", ";svg{position:absolute;top:", "px;left:", "px;}"], function (_ref7) {
  var size = _ref7.size;
  return size / 2 - size / 6;
}, function (_ref8) {
  var size = _ref8.size;
  return size / 2 - size / 6;
}, function (_ref9) {
  var size = _ref9.size;
  return size;
}, function (_ref10) {
  var size = _ref10.size;
  return size;
}, function (_ref11) {
  var size = _ref11.size;
  return size;
}, function (_ref12) {
  var theme = _ref12.theme,
    inverted = _ref12.inverted;
  return inverted ? '#fff' : theme.mainColor;
}, function (_ref13) {
  var theme = _ref13.theme,
    inverted = _ref13.inverted;
  return inverted ? theme.mainColor : '#fff';
}, function (_ref14) {
  var size = _ref14.size,
    iconSize = _ref14.iconSize;
  return (size - iconSize) / 2;
}, function (_ref15) {
  var size = _ref15.size,
    iconSize = _ref15.iconSize;
  return (size - iconSize) / 2;
});